<style media="screen" type="text/css">
  .wrapper {
    margin-top: 20vh;
    padding: 20px;
    background: #ffffff;
    text-align: center;
  }

  .emoji {
    font-size: 48px;
  }

  h1 {
    color: #002b48;
    margin-top: 30px;
    font-family: "Libre Franklin", sans-serif;
    font-size: 32px;
    font-weight: 400;
  }

  h2 {
    color: #4c5b60;
    margin-top: 20px;
    font-family: "Libre Franklin", sans-serif;
    font-size: 20px;
    font-weight: 200;
    line-height: 28px;
  }

  .logo {
    max-width: 200px;
    margin-bottom: 40px;
  }
</style>

<div class="wrapper">
  <img class="logo" alt="logo" src="//assets.provi.com/provi-logo.svg" />
  <div class="emoji">😳</div>
  <h1>Oh, four oh four.</h1>
  <h2>
    The content you're looking for doesn't exist!<br />Try hitting the back button in your browser,
    or reach out to us directly for help.
  </h2>
</div>
